import styled from 'styled-components';
import {mobileMedia} from '../../globalVariables/GlobalVariables';
import {dFlexColumn} from '../../globalVariables/GlobalFlex';

export const container = styled.div`
    height: 100%;
    width: 100%;
`;

export const main = styled.div`
    height: 100%;
    ${dFlexColumn};
    width: 100%;
    ${mobileMedia} {
        height: 100%;
        min-width: unset;
        padding-inline: 0;
    }
`;

export const rightContainer = styled.div`
    flex-shrink: 0;
    width: 350px;
    padding-inline: 1vw;
    ${dFlexColumn};
    width: 100%;
    ${mobileMedia} {
        width: 100%;
        padding-inline: 0;
        margin-top: 20px;
    }
`;